export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8002.c79d2578.jpg";